import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "conversation" ];

    initialize() {
        this.selectedConversationTarget = null;
        this.filterEvents = this.filterEvents.bind(this);
    }

    connect() {
        addEventListener("turbo:before-stream-render", this.filterEvents);
    }

    disconnect() {
        removeEventListener("turbo:before-stream-render", this.filterEvents);
    }

    conversationTargetConnected(target) {
        if (this.isTargetActive(target)) {
            this.selectedConversationTarget = target;
            target.scrollIntoView();
            return;
        }

        if (!this.selectedConversationTarget || this.selectedConversationTarget.id !== target.id) {
            return;
        }

        this.setTargetActive(target);
    }

    isTargetActive(target) {
        return target.classList.contains("active");
    }

    setTargetActive(target) {
        target.ariaSelected = true;
        target.removeAttribute("tabindex");
        target.classList.add("active");
        target.scrollIntoView();
    }

    filterEvents(event) {
        const fallbackToDefaultActions = event.detail.render
        const element = this.element;

        const paramsString = window.location.search;
        const searchParams = new URLSearchParams(paramsString);

        event.detail.render = function (streamElement) {
            // If this has nothing to do with us, or we aren't in a "search",
            // just return the default actions.
            if (streamElement.target !== element.id || !searchParams.get("query") || searchParams.get("query") === "") {
                return fallbackToDefaultActions(streamElement);
            }

            const link = streamElement.firstChild.content.firstChild.nextElementSibling;

            // If the conversation to be updated is actually already in the
            // search result list, then we should update them accordingly
            // (add the query string to the link) and then render it.
            if (element.children.namedItem(link.id)) {
                const href = new URL(link.href);
                href.searchParams.set("query", searchParams.get("query"));
                link.href = href.toString();

                return fallbackToDefaultActions(streamElement);
            }

            // Manual search on the object itself, to see if the new element
            // matches the search query or not.
            const searchQuery = searchParams.get("query").toLowerCase();
            // We have to fetch the inner element with the class x-phone-suffix.
            const phoneNumber = link.querySelector(".x-phone-suffix").innerText.toLowerCase();
            // We have to fetch the inner element with the class x-text.
            const text = link.querySelector(".x-text").innerText.toLowerCase();

            // Now if the search query is found in the phone number or in the text,
            // we can render the element.
            if (phoneNumber.includes(searchQuery) || text.includes(searchQuery)) {
                const href = new URL(link.href);
                href.searchParams.set("query", searchQuery);
                link.href = href.toString();

                return fallbackToDefaultActions(streamElement);
            }

            // Otherwise we ignore the new element as it doesn't match the search query.
        }
    }
}
